<p-steps [model]="items" [(activeIndex)]="selectedIndex" [readonly]="true"></p-steps>
<p-card [header]="(selectedIndex < regulations.length)? regulations[selectedIndex].title: 'Conferma'">
    <div class="card">
        <ng-container *ngIf="regulations[selectedIndex] !== undefined; else confirmation">
            <div class="mb-2">
                {{regulations[selectedIndex].description}}
            </div>
            <div>
                <form [formGroup]="formGroup">
                    <p-radioButton class="mr-2" [value]="regulations[selectedIndex].acceptAnswer" [label]="regulations[selectedIndex].acceptAnswer" [(ngModel)]="userRegulations[selectedIndex].acceptanceAnswer" formControlName="acceptance"></p-radioButton>
                    <p-radioButton [value]="regulations[selectedIndex].rejectAnswer" [label]="regulations[selectedIndex].rejectAnswer" [(ngModel)]="userRegulations[selectedIndex].acceptanceAnswer" formControlName="acceptance"></p-radioButton>
                </form>
            </div>
        </ng-container>
        <ng-template #confirmation>
            <ng-container *ngFor="let regulation of regulations; index as index">
                <div class="mb-2">
                    <strong>
                        {{regulation.title}}
                    </strong>
                    <br>
                    Hai selezionato: <strong>{{userRegulations[index].acceptanceAnswer}}</strong>
                </div>
            </ng-container>
        </ng-template>
    </div>
    <ng-template pTemplate="footer">
      <!-- <p-button (onClick)="isVisible = true" pRipple icon="pi pi-question-circle" class="w-full mr-1"></p-button> -->
      <div class="flex justify-content-between gap-2 w-full">
        <p-button *ngIf="selectedIndex > 0" [disabled]="!formGroup.valid" (onClick)="goBack()" pRipple label="Indietro" icon="pi pi-arrow-left"></p-button>
        <span></span>
        <p-button *ngIf="selectedIndex < (regulations.length)" (onClick)="goForward()" [disabled]="!formGroup.valid" pRipple label="Avanti" iconPos="right" icon="pi pi-arrow-right"></p-button>
        <p-button *ngIf="selectedIndex === (regulations.length)" [disabled]="!formGroup.valid" severity="success" pRipple label="Conferma" (onClick)="acceptRegulations()" icon="pi pi-check"></p-button>
      </div>
    </ng-template>
</p-card>